/**
 * action types
 */
export const SET_SUBSCRIPTION_PLANS = 'SET_SUBSCRIPTION_PLANS';
export const FETCH_SUBSCRIPTION_PLANS = 'FETCH_SUBSCRIPTION_PLANS';
